exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ol[data-v-c97e39c0],ul[data-v-c97e39c0]{padding-left:13px;margin-bottom:0}.text-sm .btn[data-v-c97e39c0]{font-size:12px!important}.topic[data-v-c97e39c0]{border-bottom:1px dashed #000;padding-bottom:8px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c97e39c0","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/school/lessonPlan/lessonPlan.vue
// module id = 120
// module chunks = 0